import { CommonModule } from '@angular/common';
import { Component, Input, TemplateRef, ViewChild, inject } from '@angular/core';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, LoaderComponent, MbsPopupType, ModalComponent } from 'mbs-ui-kit';
import { isWindows } from 'mbs-ui-shared@utils/is-windows';
import { noop } from 'rxjs';

@Component({
  selector: 'mbs-quick-restore-schema-modal',
  templateUrl: './quick-restore-schema-modal.component.html',
  standalone: true,
  imports: [CommonModule, ButtonComponent, LoaderComponent, AlertComponent, I18NextPipe, ModalComponent]
})
export class QuickRestoreSchemaModalComponent {
  ability = inject(AbilityService);

  public readonly isWindows = isWindows();
  public readonly mbsPopupType = MbsPopupType;
  private mySchemaParams: { [key: string]: string };

  @Input() ignoreIsWindows = false;
  @Input() onlyAlert = false;
  @Input() preparing = false;
  @Input() needPreparingTextShow = false;
  @Input() downloadLink: string;
  @Input() bootableUSBDescription: TemplateRef<any>;
  @Input() set createSchemaParams(params: { [key: string]: string }) {
    if (!this.isWindows && !this.ignoreIsWindows) return;

    this.mySchemaParams = params;

    if (params) this.createQuickRestoreSchema();
  }

  get createSchemaParams(): { [key: string]: string } {
    return this.mySchemaParams;
  }

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public downloadQuickRestore(): void {
    window.open(this.downloadLink, '_blank');
  }

  public stringToBase64(jsonString: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);

      reader.readAsDataURL(new Blob([jsonString], { type: 'application/json' }));
    });
  }

  public createQuickRestoreSchema(): void {
    const jsonObject = JSON.stringify(this.createSchemaParams);

    this.stringToBase64(jsonObject)
      .then((result: string) => {
        if (!result) return;

        const data = result.split('base64,');

        if (!data?.[1]) return;

        const url = 'msp360-quick-restore://data=' + data[1].trim();
        (window as any).location = encodeURI(url).replaceAll('+', '%2B');
      })
      .catch(noop);
  }
}
